import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AuthFormModal from './AuthFormModal';
import SubFormModal from './SubFormModal';
import UpdateAvatarModal from './UpdateAvatarModal';
import DarkModeMenuItem from './DarkModeMenuItem';
import { getCircularAvatar } from '../utils/cloudinaryTransform';
import storageService from '../utils/localStorage';


import {
  Button,
  Menu,
  MenuItem,
  Avatar,
  Typography,
  ListItemIcon,
  Divider,
  SvgIcon,
} from '@material-ui/core';
import { useUserMenuStyles } from '../styles/muiStyles';


import { ReactComponent as Staricon } from '../svg/staricon.svg';
// import FilterVintageIcon from '@material-ui/icons/FilterVintage';

import { ReactComponent as MyProfileIcon } from '../svg/myProfileIcon.svg';
// import AccountCircleIcon from '@material-ui/icons/AccountCircle';


import { ReactComponent as LogOutIcon } from '../svg/logOutIcon.svg';
// import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

const DesktopUserMenu = ({ user, handleLogout }) => {
  const classes = useUserMenuStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleClose();
    handleLogout();
  };

  const loggedUser = storageService.loadUser() || user;

  return (
    <div>
      {loggedUser ? (
        <>
          <Button onClick={handleMenu} className={classes.userBtn}>
            {loggedUser?.avatar?.exists ? (
              <Avatar

                alt={loggedUser.username}
                src={getCircularAvatar(loggedUser.avatar.imageLink)}
                className={classes.avatar}
              />
            ) : (
              <Avatar className={classes.avatar}>
                {loggedUser.username[0]}
              </Avatar>
            )}
            <div>
              <Typography color="secondary">{loggedUser.username}</Typography>
              <Typography variant="caption" className={classes.karmaWrapper}>
                
              <SvgIcon  style={{ marginRight: '0.2em' }} fontSize="inherit" color="secondary"> 
              <Staricon style={{ color: "secondary" }} />
              </SvgIcon > 

                {/* <Staricon
                  fontSize="inherit"
                  style={{ marginRight: '0.2em' }}
                  color="secondary"
                /> */}
                {loggedUser.karma}
              </Typography>
            </div>
          </Button>
          <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              component={RouterLink}
              to={`/u/${loggedUser.username}`}
              onClick={handleClose}
            >
              <ListItemIcon >

              {/* <box-icon name='user-circle' color='#91C788' style={{ marginRight: 7 }}  ></box-icon> My Profile */}


              <SvgIcon style={{ marginRight: 7 }} > 
              <MyProfileIcon style={{ color: "primary" }} />
              </SvgIcon > 
              My Profile
                {/* <MyProfileIcon style={{ marginRight: 7 }} /> My Profile */}
              </ListItemIcon>
            </MenuItem>
            <SubFormModal type="menu" handleCloseMenu={handleClose} />
            <UpdateAvatarModal
              handleCloseMenu={handleClose}
              user={loggedUser}
            />
            <DarkModeMenuItem closeMenu={handleClose} />
            <Divider variant="middle" />
            <MenuItem color="primary" onClick={handleLogoutClick}>
              <ListItemIcon >
              <SvgIcon style={{ marginRight: 7 }} > 
              <LogOutIcon style={{ color: "primary" }} />
              </SvgIcon > 
              Logout
              {/* <box-icon name='log-out' style={{ marginRight: 7 }} ></box-icon> Logout */}
                {/* <PowerSettingsNewIcon style={{ marginRight: 7 }} /> Logout */}
              </ListItemIcon>
            </MenuItem>
          </Menu>
        </>
      ) : (
        <div className={classes.navItems}>
          <AuthFormModal />
          <DarkModeMenuItem closeMenu={handleClose} navItem={true} />
        </div>
      )}
    </div>
  );
};

export default DesktopUserMenu;
